export default function TermsPage() {
  return (
    <div className="bg-background min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-text-primary mb-8">Terms of Service</h1>
        <div className="prose prose-lg dark:prose-invert text-text-secondary max-w-none">
          <p>Last updated: January 2026</p>
          <p>
            Welcome to Rohith's Academy. By accessing or using our website and services, you agree to be bound by these Terms of Service.
          </p>

          <h3>1. Use of Services</h3>
          <p>
            You agree to use our services only for lawful purposes and in accordance with these Terms. You are responsible for maintaining the confidentiality of your account credentials.
          </p>

          <h3>2. Intellectual Property</h3>
          <p>
            All content, including course materials, videos, and text, is the property of Rohith's Academy and is protected by copyright laws. You may not reproduce or distribute any content without our prior written permission.
          </p>

          <h3>3. User Conduct</h3>
          <p>
            You agree not to engage in any conduct that disrupts or interferes with our services, including but not limited to spamming, hacking, or harvesting user data.
          </p>

          <h3>4. Limitation of Liability</h3>
          <p>
            Rohith's Academy shall not be liable for any indirect, incidental, or consequential damages arising out of your use of our services.
          </p>

          <h3>5. Termination</h3>
          <p>
            We reserve the right to terminate or suspend your access to our services at any time, without notice, for any violation of these Terms.
          </p>
        </div>
      </div>
    </div>
  );
}

